import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/site";

/**
 * Per-page SEO: title, description, Open Graph + Twitter tags, canonical.
 */
export default function SEO({ title, description, path = "", image }) {
  const fullTitle = title
    ? `${title} · ${SITE.name}`
    : `${SITE.name} · Software Engineer & Technical Consultant`;
  const url = `https://${SITE.domain}${path}`;
  const rawImage =
    image || "/projects/orchestriq-cover.jpg";
  const ogImage = rawImage.startsWith("http")
    ? rawImage
    : `https://${SITE.domain}${rawImage}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
